import { useEffect, useRef, useState } from 'react';
import { previewVarietyFormatDrafts } from '../api';
import { buildFormatDraft } from '../components/productCreation/productCreationDrafts';

export default function usePrefilledVarietyFormats({ branchId, categoryId, varieties, setVarieties, enabled = true }) {
  const latest = useRef(varieties);
  latest.current = varieties;
  const categoryKey = String(categoryId || '');
  const pendingKey = enabled && categoryKey ? varieties.find((variety) => !variety.formatsInitialized || variety.formatsCategoryId !== categoryKey)?._draftKey : null;
  const [error, setError] = useState('');
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    if (!branchId || !pendingKey) return undefined;
    let cancelled = false;
    setError('');
    const load = async () => {
      try {
        const excludeBarcodes = latest.current.flatMap((variety) => (variety.formats || []).map((format) => format.barcode).filter(Boolean));
        const response = await previewVarietyFormatDrafts(branchId, { categoryId: Number(categoryId), excludeBarcodes });
        if (cancelled) return;
        if (!Array.isArray(response?.formats)) throw new Error('Respuesta de formatos inválida.');
        setVarieties((current) => current.map((variety) => {
          if (variety._draftKey !== pendingKey) return variety;
          const selectedCodes = new Set(response.formats.map((template) => template.productFormatCode));
          const retained = (variety.formats || []).filter((format) => !format.isDefault || format.defaultEdited || selectedCodes.has(format.productFormatCode))
            .map((format) => ({ ...format, isDefault: selectedCodes.has(format.productFormatCode) }));
          return {
            ...variety,
            formatsInitialized: true,
            formatsCategoryId: categoryKey,
            formats: [
              ...retained,
              ...response.formats.filter((template) => !retained.some((format) => format.productFormatCode === template.productFormatCode)).map((template) => ({
                ...buildFormatDraft(`${pendingKey}-default-${template.productFormatId}`, template.productFormatCode),
                barcode: template.barcode,
                productFormatName: template.productFormatName,
                barcodeIsSuggested: true,
                isDefault: true,
              })),
            ],
          };
        }));
      } catch (requestError) {
        if (!cancelled) setError(requestError?.response?.data?.message || 'No se pudieron proponer los formatos. Reintenta antes de guardar.');
      }
    };
    load();
    return () => { cancelled = true; };
  }, [branchId, categoryId, categoryKey, pendingKey, retryCount, setVarieties]);

  return { loading: Boolean(pendingKey && !error), error, retry: () => setRetryCount((value) => value + 1) };
}
